import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const searchClearFieldBtn = css`
  margin-right: ${theme.spacing(3)};
`;
